import { TextInput, required, SelectInput, useTranslate, DateTimeInput } from 'react-admin';
import { Box, Stack, Typography } from '@mui/material';
import {
  DesignatedRedPacket,
  DesignatedRedPacketStatus,
  getCriticalHitTiers,
  CriticalHitTier,
} from '../../../services/redpacketService';
import { useEffect, useState } from 'react';

interface FormProps {
  isCreate: boolean;
  record?: DesignatedRedPacket;
}

const DesignatedRedPacketForm = (props: FormProps) => {
  const { isCreate, record } = props;
  const t = useTranslate();
  const [amountChoices, setAmountChoices] = useState<{ id: string; name: string }[]>([]);

  useEffect(() => {
    const loadAmounts = async () => {
      try {
        const tiers: CriticalHitTier[] = await getCriticalHitTiers();
        const choices = tiers.map((tier) => ({
          id: tier.amount,
          name: tier.amount,
        }));
        setAmountChoices(choices);
      } catch {
        // 如果请求失败，保持为空列表，仍然允许用户手动输入
      }
    };
    loadAmounts();
  }, []);

  return (
    <Stack spacing={3} gap={2}>
      <Stack
        direction={{ xs: 'column', sm: 'row' }}
        alignItems={{ xs: 'stretch', sm: 'center' }}
        spacing={2}
        mb={1}
      >
        <Typography variant="body2" sx={{ flexBasis: '25%', flexShrink: 0 }}>
          {t('module.redpacket.walletAddress')}
        </Typography>
        <Box sx={{ flexGrow: 1 }}>
          <TextInput
            label={false}
            source="walletAddress"
            validate={[required()]}
            placeholder={t('module.redpacket.walletAddressPlaceholder')}
            fullWidth
            defaultValue={record?.walletAddress}
            disabled={!isCreate}
          />
        </Box>
      </Stack>

      <Stack
        direction={{ xs: 'column', sm: 'row' }}
        alignItems={{ xs: 'stretch', sm: 'center' }}
        spacing={2}
        mb={1}
      >
        <Typography variant="body2" sx={{ flexBasis: '25%', flexShrink: 0 }}>
          {t('module.redpacket.designatedAmount')}
        </Typography>
        <Box sx={{ flexGrow: 1 }}>
          <SelectInput
            label={false}
            source="designatedAmount"
            validate={[required()]}
            choices={amountChoices}
            optionText="name"
            optionValue="id"
            fullWidth
            defaultValue={record?.designatedAmount}
            emptyText={t('module.redpacket.pleaseSelectAmount')}
          />
        </Box>
      </Stack>

      {!isCreate && (
        <Stack
          direction={{ xs: 'column', sm: 'row' }}
          alignItems={{ xs: 'stretch', sm: 'center' }}
          spacing={2}
          mb={1}
        >
        <Typography variant="body2" sx={{ flexBasis: '25%', flexShrink: 0 }}>
          {t('module.redpacket.status')}
        </Typography>
          <Box sx={{ flexGrow: 1 }}>
            <SelectInput
              source="status"
              label={false}
              choices={[
                { id: DesignatedRedPacketStatus.PENDING, name: t('module.redpacket.pending') },
                { id: DesignatedRedPacketStatus.TRIGGERED, name: t('module.redpacket.triggered') },
                { id: DesignatedRedPacketStatus.EXPIRED, name: t('module.redpacket.expired') },
                { id: DesignatedRedPacketStatus.CANCELLED, name: t('module.redpacket.cancelled') },
              ]}
              fullWidth
              defaultValue={record?.status}
            />
          </Box>
        </Stack>
      )}

      <Stack
        direction={{ xs: 'column', sm: 'row' }}
        alignItems={{ xs: 'stretch', sm: 'center' }}
        spacing={2}
        mb={1}
      >
        <Typography variant="body2" sx={{ flexBasis: '25%', flexShrink: 0 }}>
          {t('module.redpacket.expiresAt')}
        </Typography>
        <Box sx={{ flexGrow: 1 }}>
          <DateTimeInput
            label={false}
            source="expiresAt"
            placeholder={t('module.redpacket.expiresAtPlaceholder')}
            fullWidth
            defaultValue={record?.expiresAt}
          />
        </Box>
      </Stack>
    </Stack>
  );
};

export default DesignatedRedPacketForm;
